// React hooks
import { useEffect } from "react";

// State management
import { useAppDispatch, useAppSelector } from "../../services/StoreHelper";
import { update_state_value } from "../../store/reducers/AppReducer";

// Services
import { get_agreements } from "../../services/global.services";

// Components and styles
import MobileCard from "./MobileCard/MobileCard";
import mobile_user_portal_styles from "./mobile_user_portal_styles";
import { BounceLoader } from "react-spinners";

function MobileUserPortal() {
  const dispatch = useAppDispatch();
  const { app_loading, app_error, club, agreements } = useAppSelector(
    (state) => state.app
  );

  // 🔹 Toggle language here (matches the desktop portal convention)
  const { usesSpanish } = club;

  const emptyText = usesSpanish
    ? "No se encontraron membresías."
    : "No agreements found.";

  const errorText = usesSpanish
    ? "No pudimos cargar tus membresías. Vuelve a intentarlo o comunícate con tu club."
    : "We couldn't load your memberships. Please try again or contact your club.";

  useEffect(() => {
    get_agreements(dispatch, update_state_value);
  }, [dispatch]);

  if (app_loading || !club.clubId) {
    return (
      <div style={mobile_user_portal_styles.loader}>
        <BounceLoader />
      </div>
    );
  }

  if (app_error) {
    return (
      <div style={mobile_user_portal_styles.mobile_user_portal}>
        <p role="alert" style={mobile_user_portal_styles.message}>
          {errorText}
        </p>
      </div>
    );
  }

  if (agreements.length === 0) {
    return (
      <div style={mobile_user_portal_styles.mobile_user_portal}>
        <p role="status" style={mobile_user_portal_styles.message}>
          {emptyText}
        </p>
      </div>
    );
  }

  return (
    <div style={mobile_user_portal_styles.mobile_user_portal}>
      <div style={mobile_user_portal_styles.form}>
        {agreements.map((contract: any) => (
          <MobileCard
            key={contract.id || contract.contractId}
            contract={contract}
            refresh={() => get_agreements(dispatch, update_state_value)}
          />
        ))}
      </div>
    </div>
  );
}

export default MobileUserPortal;